import { getNetCheckUrl } from "@/config/config";
import { detectOS, DownloadItem, FocusSDK, isFocusEnv } from "@/utils";
import NetworkCheck from "@/utils/NetworkCheck";
import { changeEgovUrl } from "@/utils/tools";
import { message } from "antd";
import { v4 } from "uuid";
import {
  checkDownloadError,
  getGlobalStatus,
  getSuccessDownloadTaskCount
} from "@/components/Joyspace/components/BatchDownloadPanel/BasisComponents/utils";
import {
  ErrorCode,
  GlobalStatus,
  Status,
  StatusErrorDesc
} from "@/components/Joyspace/components/BatchDownloadPanel/type";
import { convertDownloadUnit, createDownloadItem, getDownloadFileStatus } from "../utils";
import { EventEmitter } from "events";
import {
  downLoadFile,
  getDownloadFileResp,
  getFileName,
  getFileUrl,
  getFileExists
} from "@/utils/chat/index";
import { addXclient } from "@/utils/addToken";
import { ChatMessageType, Employee } from "@/types/chat";
import i18n from "@/i18n";
import { throttle } from "lodash";
import { getFileDownloadBzOptions } from "@/utils/chat/message";

// 批量下载服务
class ImDownloadController extends EventEmitter {
  private static instance: ImDownloadController | null;
  private static netServer: any;
  // 初始化实例
  public static getInstance(): ImDownloadController {
    if (!this.instance) {
      this.instance = new ImDownloadController();
      this.instance.getPath();
      // 实例化 netServer服务
      this.netServer = NetworkCheck.getInstance({
        url: getNetCheckUrl()
      });
      // 初始化 isNetworkOnline
      this.instance.initNetwork();
    }
    return this.instance;
  }
  private gid = "";
  private path = "";
  private working = false; // 标记是否有任务进行中
  private taskQueue: any[] = [];
  private currentTask: any; // 当前进行任务
  private setList: any;
  private id = 0;
  private timer: any;
  private isNetworkOnline = false;
  private currentEmployee: Employee | undefined;

  constructor() {
    super();
    this.onlineFn = throttle(this.onlineFn, 3000);
    this.offlineFn = throttle(this.offlineFn, 3000);
  }

  onlineFn() {
    // console.log("触发online--");
    // ImDownloadController.netServer.stopCheck();
    this.isNetworkOnline = true;
  }

  offlineFn() {
    // console.log("触发offline--");
    // if (!ImDownloadController.netServer.isStartCheck()) {
    //   ImDownloadController.netServer.startCheck();
    // }
    this.handleTaskCancelAll(this.gid);
    this.isNetworkOnline = false;
  }

  proxy(callback: any) {
    this.setList = callback;
  }
  getGid() {
    return this.gid;
  }
  setGid(gid = "") {
    this.gid = gid;
  }
  setCurrentEmployee(employee: Employee) {
    this.currentEmployee = employee;
  }
  setDownloadPath(downloadPath: string) {
    console.log("downloadPath=>", downloadPath);
    this.path = downloadPath;
  }
  // start 网络初始化
  async initNetwork() {
    this.isNetworkOnline = await ImDownloadController.netServer.checkNet();
    ImDownloadController.netServer.off("online", this.onlineFn.bind(this));
    ImDownloadController.netServer.off("offline", this.offlineFn.bind(this));
    ImDownloadController.netServer.on("online", this.onlineFn.bind(this));
    ImDownloadController.netServer.on("offline", this.offlineFn.bind(this));
  }
  // 获取网络状态
  getNetworkStatus() {
    return this.isNetworkOnline;
  }
  // 移除监听器
  offNetworkListener() {
    // ImDownloadController.netServer?.off('online', () => {});
    // ImDownloadController.netServer?.off('offline', () => {});
  }
  // 添加监听器
  // onNetworkListener() {
  //     ImDownloadController.netServer?.on('online', function onLine() {
  //         console.log('sada=============>');
  //         // this.isNetworkOnline = true;
  //     });
  //     ImDownloadController.netServer?.on('offline', function offline() {
  //         console.log('offline=============>');
  //         // this.isNetworkOnline = false;
  //     });
  // }
  // end
  getWorking() {
    return this.working;
  }
  checkLocalPathExist(downLocalPath: string) {
    return new Promise((resolve) => {
      if (!isFocusEnv()) {
        resolve(true);
      }
      if (!downLocalPath) {
        resolve(false);
      }
      FocusSDK.checkLocalPathExist(downLocalPath, (exists: boolean) => {
        resolve(exists);
      });
    });
  }
  // 选择下载路径
  chooseDownloadPage(callback: any) {
    FocusSDK.showOpenDialog(
      (res) => {
        // console.log("res-", res);
        this.setPath(res);
        callback?.(res);
      },
      {
        properties: ["openDirectory"],
        defaultPath: this.getPath()
      }
    );
  }
  // 获取
  getPath() {
    const defaultPath = isFocusEnv()
      ? this.path ||
        JSON.parse(FocusSDK.getConfigData()).defaultDownloadPath ||
        FocusSDK.getDownloadPath()
      : "";
    // ? FocusSDK.getDownloadPath()
    // : localStorage.getItem("defaultJoyspaceDownloadPath");
    this.path = defaultPath;
    // console.log("默认下载路径===>", this.path);
    return this.path;
  }
  async setPath(path: string) {
    const isExist = await this.checkLocalPathExist(path);
    console.log("isExist=>", isExist);
    if (isExist) {
      this.path = path;
      // FocusSDK.setJoySpaceDownloadPath(path);
      // isFocusEnv() && FocusSDK.setConfigData("defaultJoyspaceDownloadPath", path);
      console.warn("设置下载路径", path, this.path);
      return;
    }
    message.error(StatusErrorDesc.PATH_NOT_EXIST);
  }
  async hasLocalFile(path: string, title: string): Promise<any> {
    const localPath = `${path}${detectOS() === "Win" ? "\\" : "/"}${title}`;
    return await this.checkLocalPathExist(localPath);
  }
  // 判重处理
  async getNewItem(item: any, index = 0, newTitle = item.title): Promise<any> {
    if (!isFocusEnv()) {
      item.downloadId = `${item.id}_${v4()}_${this.id}`;
      return createDownloadItem(item);
    }
    this.id++;
    const hasFile = await this.hasLocalFile(item.path, newTitle);
    console.log("hasFile=>", hasFile);
    if (hasFile) {
      // eslint-disable-next-line no-param-reassign
      index++;
      const idx = item.title.lastIndexOf(".");
      const startStr = item.title.substring(0, idx);
      const endStr = item.title.substring(idx, item.title.length);
      // eslint-disable-next-line no-param-reassign
      newTitle = idx !== -1 ? `${startStr}(${index})${endStr}` : `${endStr}(${index})`;
      return await this.getNewItem(item, index, newTitle);
    }
    // item.id = `${item.id}_${v4()}_${this.id}`;
    item.downloadId = `${item.id}_${v4()}_${this.id}`;
    newTitle && (item.title = newTitle);
    return createDownloadItem(item);
  }
  // 添加任务
  async addTask(
    newTaskList: any[] = [],
    callback: () => void,
    onFinish: (currentItem: any) => void
  ) {
    let newList: any[] = [];
    for (let item of newTaskList) {
      item.title = item.name;
      const newItem = await this.getNewItem({ ...item });
      // newItem.path = this.path;
      newList.push({ ...newItem, onFinish });
    }
    this.taskQueue = this.taskQueue.concat(newList);
    callback?.();
    this.startTask(); // 开启任务
  }
  // 排序任务
  sortTask() {
    return this.getTaskQueue()
      .filter((item: any) => item.status === Status.WAITING)
      .sort((a: any, b: any) => a?.index - b?.index);
  }
  // 开始任务
  async startTask() {
    // 排序
    const sortList = this.sortTask();
    if (!sortList.length) {
      console.warn("无等待中的任务");
      return;
    }
    const item = sortList[0];
    // 校验网络
    if (!this.isNetworkOnline) {
      console.warn("网络异常");
      this.changeTask({
        ...item,
        status: item.status === Status.PROGRESS ? ErrorCode.NETWORK_ERROR : Status.CANCEL
      });
      this.startTask();
      return;
    }
    if (this.working) {
      console.warn("当前有任务进行中");
      return;
    }
    // 对文件名超多150字符直接拦截，报错.因为Electron保存会失败
    const len = item?.title?.length || 0;
    if (len > 150) {
      this.timer && clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.changeTask({ ...item, status: ErrorCode.ERROR });
        this.startTask();
      }, 700);
      return;
    }
    if (!item.url || item.url.indexOf("http") === -1) {
      this.changeTask({ ...item, status: ErrorCode.ERROR });
      this.working = false;
      this.startTask();
      return;
    }
    if (!FocusSDK.isPrivateNet() && item.type === ChatMessageType.EGOV_FILE) {
      this.changeTask({ ...item, status: ErrorCode.PRIVATENET_EGOV_FILE });
      this.working = false;
      this.startTask();
      console.warn("专网文件");
      return;
    }
    // console.log(item, 'item===>');
    // 校验下载路径
    const isExist = await this.checkLocalPathExist(item.path);
    if (!isExist) {
      this.changeTask({ ...item, status: ErrorCode.PATH_NOT_EXIST });
      this.working = false;
      this.startTask();
      console.warn("下载路径不存在");
      return;
    }
    if (item.resume) {
      // this.working = true;
      // (item as any)?.cancel();
      delete item.resume;
      item.currentProgress = 0;
      item.currentSize = "0";
      this.currentTask = { ...item };
      // item.resume();
      console.warn("执行任务->重试");
      // return;
    }
    const url = getFileUrl(item.url, getFileDownloadBzOptions(item, this.currentEmployee));
    this.downlaod({
      url: await addXclient(url),
      path: item.path,
      filename: item.title,
      currentItem: { ...item }
    });
    // const { code, data } = await getDocumentDownloadPath(item.pageId);
    // switch (code) {
    //   case ErrorCode.FILE_DEL_ERROR:
    //     item.status = ErrorCode.FILE_DEL_ERROR;
    //     this.changeTask(item);
    //     this.startTask();
    //     console.warn("下载的源文件不存在");
    //     break;
    //   case ErrorCode.NO_PERMISSION:
    //     item.status = ErrorCode.NO_PERMISSION;
    //     this.changeTask(item);
    //     this.startTask();
    //     console.warn("下载的源文件无权限");
    //     break;
    //   default:
    //     console.warn("准备下载");
    //     this.downlaod({
    //       url: changeEgovUrl(data.link),
    //       path: item.path,
    //       filename: item.title,
    //       currentItem: { ...item }
    //     });
    // }
  }
  // 重写某个任务
  changeTask(newItem: any) {
    let idx = this.taskQueue.findIndex((item: any) => item.downloadId === newItem.downloadId);
    if (idx !== -1) {
      // const olbItem = this.taskQueue[idx];
      this.taskQueue.splice(idx, 1, { ...newItem });
    }
    // console.log('changeTask===>', this.taskQueue);
    const newList = this.getGidByTaskQueue(this.gid);
    this.setList([...newList]);
    this.emit("group-download-control-event", newList);
  }
  // 修改全部等待中任务状态
  changeWaitingTaskAll(status: Status | ErrorCode) {
    this.taskQueue = this.taskQueue.map((item: any) => {
      if (item.status === Status.WAITING) {
        item.status = status;
      }
      return item;
    });
    const newList = this.getGidByTaskQueue(this.gid);
    this.setList([...newList]);
    this.emit("group-download-control-event", newList);
  }
  // 修改全部的任务状态
  changeTaskAll(status: Status | ErrorCode) {
    this.taskQueue = this.taskQueue.map((item: any) => {
      item.status = status;
      return item;
    });
    const newList = this.getGidByTaskQueue(this.gid);
    this.setList([...newList]);
    this.emit("group-download-control-event", newList);
  }
  // 获取任务队列
  getTaskQueue() {
    return this.taskQueue;
  }
  // 获取任务队列
  getGidByTaskQueue(gid = "") {
    return this.taskQueue.filter((item) => item.gid === gid);
  }
  // 获取等待中和进行中
  getProgressTask() {
    return this.taskQueue.filter((item: any) => item.status === Status.WAITING);
  }
  // 清空任务
  clearTaskAll() {
    const item: any = this.taskQueue.find((item: any) => item.status === Status.PROGRESS);
    this.currentTask = null;
    this.taskQueue = []; // 置空任务队列
    this.working = false;
    this.id = 0;
    item?.cancel();
    this.offNetworkListener();
  }
  clearGidByTask(gid = "") {
    const item: any = this.taskQueue.find(
      (item: any) => item.status === Status.PROGRESS && item.gid === gid
    );
    this.currentTask?.cancel && this.currentTask?.cancel();
    this.currentTask?.gid === gid && (this.currentTask = null);
    // this.taskQueue = []; // 置空任务队列
    this.taskQueue = this.taskQueue.filter((item: any) => item.gid !== gid);
    item && (this.working = false);
    !this.taskQueue.length && (this.id = 0); // 排序值
    item?.cancel();
    this.offNetworkListener();
    this.emit("group-download-control-event", []);
  }
  // 执行下载
  downlaod({
    url,
    path,
    filename,
    currentItem
  }: {
    url: string;
    path: string;
    filename: string;
    currentItem: any;
  }) {
    if (!this.working) {
      this.working = true;
      console.warn("开始下载");
      let flag = false; // 用于区分用户是手动触发，还是downloadFile触发的
      return new Promise((resolve, reject) => {
        let resumeLimitCount = 0;
        let isExpired = false;
        try {
          if (isFocusEnv()) {
            FocusSDK.downloadFile(url, {
              saveAs: false, // 是否另存为
              viewFile: false, // 预览文件
              defaultPath: path, // 下载路径
              filename, // 文件名称
              alreadySaveAs: false, // 本地是否已存在
              isBatchDownload: true,
              onStarted: (downloadItem: DownloadItem) => {
                this.objectAssignTask({ ...currentItem, ...downloadItem });
                this.changeTask(this.currentTask);
              },
              onProgress: async (progress: any) => {
                if (!this.isNetworkOnline) {
                  flag = true;
                  this.currentTask.cancel();
                  return;
                }
                if (progress.status === "interrupted") {
                  if (progress.totalBytes === 0) {
                    const code = await getDownloadFileStatus(url);
                    if (code === 506) {
                      message.error("当前下载人数较多，请稍后重试");
                      this.currentTask?.cancel();
                      this.objectAssignTask({
                        status: !this.isNetworkOnline ? ErrorCode.NETWORK_ERROR : Status.CANCEL
                      });
                      this.changeTask(this.currentTask);
                      this.working = false;
                      this.startTask();
                      reject(new Error("download 506"));
                    }
                  } else {
                    try {
                      const exists = await getFileExists(url);
                      if (!exists) {
                        isExpired = true;
                        // this.currentTask?.cancel(false, "1017005");
                        this.objectAssignTask({
                          status: ErrorCode.FILE_EXPIRED
                        });
                        this.changeTask(this.currentTask);
                        this.currentTask?.cancel();
                        this.working = false;
                        this.startTask();
                        console.warn("文件过期");
                      } else {
                        if (resumeLimitCount >= 5) {
                          console.warn("开始重试--重试次数-->", resumeLimitCount);
                          this.objectAssignTask({
                            status: ErrorCode.ERROR
                          });
                          this.changeTask(this.currentTask);
                          this.currentTask?.cancel();
                          this.working = false;
                          this.startTask();
                          reject(new Error("超出resume重试次数"));
                        } else if (this.currentTask.resume) {
                          resumeLimitCount++;
                          this.currentTask?.resume();
                        }
                        return;
                      }
                    } catch (error) {
                      this.objectAssignTask({
                        status: ErrorCode.NETWORK_ERROR
                      });
                      this.changeTask(this.currentTask);
                    }
                  }
                  return;
                }
                this.objectAssignTask({
                  status: Status.PROGRESS,
                  currentProgress: Number(progress.percent),
                  size: convertDownloadUnit(progress.totalBytes),
                  currentSize: convertDownloadUnit(progress.transferredBytes)
                });
                this.changeTask(this.currentTask);
              },
              onCancel: async (_) => {
                if (!this.taskQueue.length) {
                  return;
                } else if (isExpired) {
                  this.objectAssignTask({
                    status: ErrorCode.FILE_EXPIRED
                  });
                } else if (resumeLimitCount >= 5) {
                  this.objectAssignTask({
                    status: ErrorCode.ERROR
                  });
                  if (this.currentTask.resume) {
                    delete this.currentTask.resume;
                    delete this.currentTask.pause;
                    delete this.currentTask.cancel;
                  }
                } else if (flag && this.currentTask.status === Status.PROGRESS) {
                  flag = false;
                  this.objectAssignTask({
                    status: ErrorCode.NETWORK_ERROR
                  });
                } else {
                  this.objectAssignTask({
                    status: Status.CANCEL
                  });
                }

                this.currentTask.currentProgress = 0;
                this.currentTask.currentSize = "0";
                this.changeTask(this.currentTask);
                this.working = false;
                this.startTask();
                console.log("触发了取消");
                console.log("onCancel==>", this.currentTask);
                // reject(new Error('cancel'));
              },
              onPause: () => {
                this.currentTask?.cancel();
                console.log("触发了暂停");
                console.log("onPause==>", this.currentTask);
              },
              onResume: () => {
                if (!this.working) {
                  this.startTask();
                }
                console.log("我点击了重试");
                console.log("onResume==>", this.currentTask);
              },
              onFinish: async (file, data) => {
                console.log("path=>", file.path, data);
                console.warn("下载成功");
                this.objectAssignTask({
                  status: Status.SUCCESS
                });
                this.changeTask(this.currentTask);
                this.working = false;
                this.startTask();
                currentItem.onFinish({ ...currentItem, path: file.path });
                resolve(data);
              },
              onError: async (error) => {
                console.log(error, "==========>");
                console.warn("下载异常");
                let status = ErrorCode.ERROR;
                if (!this.isNetworkOnline) {
                  status = ErrorCode.NETWORK_ERROR;
                }
                const isExist = await this.checkLocalPathExist(currentItem.path);
                if (!isExist) {
                  status = ErrorCode.PATH_NOT_EXIST;
                }

                this.objectAssignTask({
                  ...currentItem,
                  status
                });
                delete this.currentTask?.resume;
                delete this.currentTask?.pause;
                delete this.currentTask?.cancel;
                this.currentTask.currentProgress = 0;
                this.currentTask.currentSize = "0";
                this.changeTask(this.currentTask);
                this.working = false;
                this.startTask();
                console.log("onError==>", this.currentTask);
                // reject(new Error(JSON.stringify({ error })));
              }
            });
          } else {
            const name = getFileName(currentItem);
            downLoadFile(name, url, "", {
              onFinish: () => {
                this.objectAssignTask({
                  status: Status.SUCCESS
                });
                this.changeTask({ ...currentItem, status: Status.SUCCESS });
                this.working = false;
                this.startTask();
                currentItem.onFinish({ ...currentItem });
                resolve(currentItem);
              },
              onError: () => {
                let idx = this.taskQueue.findIndex(
                  (item: any) => item.downloadId === currentItem.downloadId
                );
                if (idx !== -1) {
                  this.taskQueue.splice(idx, 1);
                }
                this.working = false;
                this.startTask();
              }
            });
          }
        } catch (e) {
          reject(e);
          console.log("catch error", e);
          this.objectAssignTask({
            ...currentItem,
            status: ErrorCode.ERROR
          });
          this.changeTask(this.currentTask);
          console.log("catchonError==>", this.currentTask);
        }
      });
    }
  }
  objectAssignTask(options: any) {
    this.currentTask = { ...this.currentTask, ...options };
  }
  // 异常处理 start
  // 无网络处理
  handleNetwrokByList() {
    this.taskQueue = this.taskQueue.map((item: any) => {
      if (item.status === Status.WAITING) {
        item.status = Status.CANCEL;
      } else if (item.status === Status.PROGRESS) {
        (item as any)?.cancel();
        item.status = ErrorCode.NETWORK_ERROR;
      } else if (item.status === Status.CANCEL || item.status === Status.RETRY) {
        item.status = ErrorCode.NETWORK_ERROR;
      }
      return item;
    });
    const newList = this.getGidByTaskQueue(this.gid);
    this.setList([...newList]);
    this.emit("group-download-control-event", newList);
  }
  // end
  // 全部重试
  handleTaskRetryAll(gid: any) {
    if (!this.isNetworkOnline) {
      return message.error(i18n.t("Network Error"));
    }
    for (let item of this.taskQueue) {
      if (item.gid === gid) {
        if (!this.isNetworkOnline && item.status !== Status.SUCCESS) {
          // item.status === Status.PROGRESS && item.pause && item.pause();
          item.status = ErrorCode.NETWORK_ERROR;
        } else if (
          checkDownloadError(item.status as ErrorCode) ||
          item.status === Status.CANCEL ||
          item.status === Status.RETRY
        ) {
          item.status = Status.WAITING;
        }
      }
    }
    // if(this.currentTask) {
    //   this.currentTask.cancel()
    // }
    const newList = this.getGidByTaskQueue(this.gid);
    this.setList([...newList]);
    this.emit("group-download-control-event", newList);
    this.isNetworkOnline && !this.working && this.startTask();
  }
  // 全部取消
  handleTaskCancelAll(gid: any) {
    console.log("this.taskAueue=>", this.taskQueue);
    for (let item of this.taskQueue) {
      if (item.gid === gid) {
        if (item.status === Status.WAITING) {
          item.status = Status.CANCEL;
        } else if (item.status === Status.PROGRESS) {
          item.cancel && item.cancel();
        }
      }
    }
    const newList = this.getGidByTaskQueue(this.gid);
    this.setList([...newList]);
    this.emit("group-download-control-event", newList);
  }
  getGidByStateInfo(gid = "") {
    let downlaodInfo = { status: GlobalStatus.SUCCESS_ALL, currentCount: 0, totalCount: 0 };
    if (!gid) {
      return downlaodInfo;
    }
    let taskList = this.taskQueue.filter((item: any) => item.gid === gid);
    downlaodInfo.status = getGlobalStatus(taskList);
    downlaodInfo.currentCount = getSuccessDownloadTaskCount(taskList);
    downlaodInfo.totalCount = taskList.length;
    return downlaodInfo;
  }
}

export default ImDownloadController;
